// @flow
import { connect } from 'react-redux';
import { PickLine } from '../../components/common';
import { terminateLine } from '../../modules/SuspendSwapTerminate';
import I18n from '../../lib/i18n';
import { subscriptionToPhoneNumber, visibleSubscriptionsSelector } from '../../modules/Dashboard';
import FormatService from '../../lib/format';

import type { State } from '../../modules/reducers';
import type { StateProps, DispatchProps } from '../../components/common/PickLine/PickLine';

const mapStateToProps = (state: State): StateProps => ({
  subscriptions: visibleSubscriptionsSelector(state),
  title: I18n.t('Dashboard.LineTermination.selectSubscription'),
  confirmButtonText: I18n.t('Dashboard.LineTermination.terminate'),
  modalContent: subscription =>
    I18n.t('Dashboard.LineTermination.modalConfirmationText', {
      phoneNumber: FormatService.formatPhone(subscriptionToPhoneNumber(subscription)),
    }),
  loadingSelector: 'terminateSuccess',
});

const mapDispatchToProps: DispatchProps = {
  onConfirm: terminateLine,
};

export default connect(mapStateToProps, mapDispatchToProps)(PickLine);
